(function () {
  const systemTitles = {
    en: 'Shipping & Returns Policy',
    de: 'Versand- & Rückgabebedingungen',
    es: 'Política de envíos y devoluciones',
    fr: 'Politique de livraison et de retour',
    it: 'Spedizioni e resi',
    pt: 'Política de envios e devoluções',
    'pt-pt': 'Política de envios e devoluções'
  };

  const language = (document.documentElement.lang || 'en').toLowerCase();
  const systemTitle = systemTitles[language] || systemTitles[language.split('-')[0]];

  if (systemTitle) {
    const isShippingPolicy =
      location.pathname.endsWith('/policies/shipping-policy') ||
      document.body.dataset.awPolicyPreview === 'shipping-policy';

    if (isShippingPolicy) {
      document.title = systemTitle;

      const policyHeading = document.querySelector('.shopify-policy__title h1');
      if (policyHeading) policyHeading.textContent = systemTitle;

      document
        .querySelectorAll('.aw-breadcrumbs [aria-current="page"]')
        .forEach(function (breadcrumb) {
          breadcrumb.textContent = systemTitle;
        });
    }

    document
      .querySelectorAll('footer a.text-sm.link-faded[href*="/policies/shipping-policy"]')
      .forEach(function (link) {
        link.textContent = systemTitle;
      });
  }
})();

document.addEventListener(
  'click',
  function (event) {
    const link = event.target.closest(
      '.shopify-policy__container a[href^="#"]'
    );

    if (!link) return;

    const target = document.getElementById(
      decodeURIComponent(link.hash.slice(1))
    );

    if (!target) return;

    event.preventDefault();
    history.pushState(null, '', link.hash);
    target.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  },
  true
);
